interface IconCardProps {
  className: string;
  Icon?: React.FC<React.SVGProps<SVGSVGElement>>;
  src?: string;
  title: string;
  text: string;
  color?: string;
}

export const IconCard = ({
  className,
  Icon,
  src,
  title,
  text,
  color,
}: IconCardProps) => {
  return (
    <div
      className={`border border-white rounded-xl shadow-md p-8 ${className}`}
    >
      {Icon ? (
        <Icon className="w-6 h-6 mb-4" style={{ color }} />
      ) : src ? (
        <img src={src} alt="Icon" className="w-6 h-6 mb-4" />
      ) : null}
      <h5 className="font-bold mt-4 mb-4 text-lg">{title}</h5>
      <p className="text-[#49505A]">{text}</p>
    </div>
  );
};
